<div class="phx-panel">
  <h4 class="phx-panel-header-title" *ngIf="headerTitle && !useCustomTitle">{{headerTitle}}</h4>
  <ng-container *ngIf="useCustomTitle">
    <h4 class="phx-panel-header-title">
      <ng-content select="[custom-title]"></ng-content>
    </h4>
  </ng-container>
  <ng-content></ng-content>
</div>